(function () {

  var CANNAZO_VENDOR = 'Cannazo';

  var CANNAZO_RULES = [
    { minValue: 150000,  gift: { variantId: 44587259854931, qty: 1 },  code: 'CANNAZO1500' },
    { minValue: 350000,  gift: { variantId: 42962467651667, qty: 1 },  code: 'CANNAZO3500' },
    { minValue: 550000,  gift: { variantId: 44587259822163, qty: 1 },  code: 'CANNAZO5500' },
    { minValue: 800000,  gift: { variantId: 42478632894547, qty: 1 }, code: 'CANNAZO8000' },
    { minValue: 1500000, gift: { variantId: 42350591377491, qty: 1 },  code: 'CANNAZO15000' }
  ];

  var NAMASTE_RULES = [
    { minValue: 150000,  gift: { variantId: 43191228170323, qty: 1 }, code: 'NAMASTE1500' },
    { minValue: 350000,  gift: { variantId: 43191181181011, qty: 1 }, code: 'NAMASTE3500' },
    { minValue: 400000,  gift: { variantId: 43191192354899, qty: 1 }, code: 'NAMASTE4000' },
    { minValue: 500000,  gift: { variantId: 43191204970579, qty: 1 }, code: 'NAMASTE5000' },
    { minValue: 700000,  gift: { variantId: 43191032021075, qty: 1 }, code: 'NAMASTE7000' }  // Updated
  ];

  var ALL_GIFT_IDS = [];
  CANNAZO_RULES.forEach(function (r) {
    if (ALL_GIFT_IDS.indexOf(r.gift.variantId) === -1)
      ALL_GIFT_IDS.push(r.gift.variantId);
  });
  NAMASTE_RULES.forEach(function (r) {
    if (ALL_GIFT_IDS.indexOf(r.gift.variantId) === -1)
      ALL_GIFT_IDS.push(r.gift.variantId);
  });

  var isRunning = false;
  var lastCartToken = '';
  var lastNonGiftTotal = -1;
  var lastHasCannazo = null;

  function getCart() {
    return fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function addGifts(gifts) {
    var items = gifts.map(function (g) {
      return {
        id: g.variantId,
        quantity: g.qty,
        properties: { _is_free_gift: 'yes' }
      };
    });
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  function removeGift(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function removeAllGifts(cartItems) {
    var toRemove = cartItems.filter(function (item) {
      return ALL_GIFT_IDS.indexOf(item.variant_id) !== -1 &&
        item.properties &&
        item.properties._is_free_gift === 'yes';
    });
    var promise = Promise.resolve();
    toRemove.forEach(function (item) {
      promise = promise.then(function () {
        return removeGift(item.key);
      });
    });
    return promise;
  }

  function applyDiscount(code) {
    return fetch('/discount/' + code, {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).catch(function () {});
  }

  function removeDiscount() {
    return fetch('/discount/', {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).catch(function () {});
  }

  function getMatchedRule(rules, total) {
    var matched = null;
    for (var i = rules.length - 1; i >= 0; i--) {
      if (total >= rules[i].minValue) {
        matched = rules[i];
        break;
      }
    }
    return matched;
  }

  function giftsMatch(cartItems, targetGifts) {
    var currentGifts = cartItems.filter(function (item) {
      return ALL_GIFT_IDS.indexOf(item.variant_id) !== -1 &&
        item.properties &&
        item.properties._is_free_gift === 'yes';
    });
    if (currentGifts.length !== targetGifts.length) return false;
    return targetGifts.every(function (tg) {
      return currentGifts.some(function (cg) {
        return cg.variant_id === tg.variantId && cg.quantity === tg.qty;
      });
    });
  }

  function updateFreeGifts() {
    if (isRunning) return;
    isRunning = true;

    getCart().then(function (cart) {

      var cartSignature = cart.token + '_' + cart.total_price + '_' + cart.item_count;
      if (cartSignature === lastCartToken) {
        isRunning = false;
        return;
      }

      var nonGiftTotal = 0;
      var hasCannazo = false;

      cart.items.forEach(function (item) {
        var isGift = item.properties && item.properties._is_free_gift === 'yes';
        if (!isGift) {
          nonGiftTotal += item.line_price;
          if (item.vendor === CANNAZO_VENDOR) {
            hasCannazo = true;
          }
        }
      });

      if (nonGiftTotal === lastNonGiftTotal && hasCannazo === lastHasCannazo) {
        lastCartToken = cartSignature;
        isRunning = false;
        return;
      }

      lastNonGiftTotal = nonGiftTotal;
      lastHasCannazo = hasCannazo;
      lastCartToken = cartSignature;

      var cannazоRule = hasCannazo ? getMatchedRule(CANNAZO_RULES, nonGiftTotal) : null;
      var namasteRule = !hasCannazo ? getMatchedRule(NAMASTE_RULES, nonGiftTotal) : null;

      var activeRule = hasCannazo ? cannazоRule : namasteRule;

      if (!activeRule) {
        var hadGifts = cart.items.some(function (item) {
          return ALL_GIFT_IDS.indexOf(item.variant_id) !== -1 &&
            item.properties &&
            item.properties._is_free_gift === 'yes';
        });
        if (hadGifts) {
          return removeAllGifts(cart.items)
            .then(function () { return removeDiscount(); })
            .then(function () {
              lastCartToken = '';
              lastNonGiftTotal = -1;
              lastHasCannazo = null;
              isRunning = false;
            });
        }
        isRunning = false;
        return;
      }

      var giftsToAdd = [activeRule.gift];

      if (giftsMatch(cart.items, giftsToAdd)) {
        isRunning = false;
        return;
      }

      return removeAllGifts(cart.items)
        .then(function () { return addGifts(giftsToAdd); })
        .then(function (result) {
          if (result && result.status === 422) {
            console.log('Free gift add failed:', result.description);
            isRunning = false;
            return;
          }
          lastCartToken = '';
          lastNonGiftTotal = -1;
          lastHasCannazo = null;
          return applyDiscount(activeRule.code);
        })
        .then(function () { isRunning = false; })
        .catch(function (err) {
          console.error('Free gift error:', err);
          isRunning = false;
        });

    }).catch(function (err) {
      console.error('Cart fetch error:', err);
      isRunning = false;
    });
  }

  updateFreeGifts();
  setInterval(updateFreeGifts, 8000);

})();